import "../css/Layout.css";

export default function Layout({ children }) {
  return <main className="page-container">{children}</main>;
}
